import React from 'react';
import { observer } from 'mobx-react';
import HistoryMenuComponent from './History-menu.component';
import useHistoryMenu from './useHistoryMenu';

const Container: React.FC = () => {
    const { map, lang, user, devices, state, handlers, groups } = useHistoryMenu();
    return (
        <>
            <HistoryMenuComponent
                devices={devices.deviceList}
                groups={groups}
                fromDateFilterCurrent={state.fromDateFilterCurrent}
                toDateFilterCurrent={state.toDateFilterCurrent}
                dateFilter={map.dateFilter}
                lang={lang.lang}
                selectedDevice={map.selectedDevice}
                userType={user.type}
                addGroupVisible={state.addGroupVisible}
                addDialogOpen={state.addDialogOpen}
                speedDialHover={state.speedDialHover}
                trackMode={map.trackMode}
                timezone={user.settings.timezone ?? 0}
                onFromDateChange={handlers.handleFromDateChange}
                onToDateChange={handlers.handleToDateChange}
                onDateFilterChange={handlers.handleDateFilterChange}
                onDeviceSelect={handlers.handleDeviceSelect}
                onAddGroupOpen={handlers.handleAddGroupOpen}
                onAddGroupClose={handlers.handleAddGroupClose}
                onAddDeviceInDbOpen={handlers.handleAddDeviceInDbOpen}
                onAddDeviceOpen={handlers.handleAddDeviceOpen}
                onAddDialog={handlers.handleAddDialog}
                onAddDiologClose={handlers.handleAddDiologClose}
                onSpeedDialHoverStart={handlers.handleSpeedDialHoverStart}
                onSpeedDialHoverStop={handlers.handleSpeedDialHoverStop}
                onSwitchTrackMode={handlers.handleSwitchTrackMode}
                onUpdateClick={handlers.handleUpdateClick}

                onDeviceInfoOpen={handlers.handleDeviceInfoOpen}
                onDeviceSettingsOpen={handlers.handleDeviceSettingsOpen}
                onDeviceDescriptionOpen={handlers.handleDeviceDescriptionOpen}
                onDeviceBtnHoverStop={handlers.handleDeviceBtnHoverStop}
                onDeviceBtnHoverStart={handlers.handleDeviceBtnHoverStart}
            />
        </>
    );
};

const HistoryMenuContainer = observer(Container);

export default HistoryMenuContainer;
